import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from "./components/ui/provider";
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { IntlProvider } from 'react-intl'
import TagManager from 'react-gtm-module';
import App from './App';
import Fonts from './utils/fonts';


const tagManagerArgs = {
  gtmId: 'GTM-W7ZFZNFW'
}
TagManager.initialize(tagManagerArgs);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const targetLocale = "en";
const messages = [];

root.render(
  <StrictMode>
    <HelmetProvider>
      <IntlProvider messages={messages} locale={targetLocale} defaultLocale="en">
        <Provider forcedTheme="light">
          <Fonts />
          <App />
        </Provider>
      </IntlProvider>
    </HelmetProvider>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
